import React from 'react';
import { mockTenants } from '../../../services/mockData';

const Tenants = () => (
  <div className="fade-in">
    <div className="page-header">
      <div className="breadcrumb">Society Reports <span>/ Tenants</span></div>
      <h2>List Of Tenants</h2>
    </div>

    <div className="card">
      <div className="card-header">
        <span className="card-title">Tenants Details</span>
        <div className="btn-group">
          <button className="btn btn-outline btn-sm">Copy</button>
          <button className="btn btn-outline btn-sm">Excel</button>
          <button className="btn btn-outline btn-sm">Column visibility</button>
        </div>
      </div>

      <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'flex-end' }}>
        <input type="text" placeholder="Search..." className="form-control" style={{ maxWidth: '220px' }} />
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Select</th>
              <th>Tenant Name</th>
              <th>Flat</th>
              <th>Intercom</th>
              <th>Status</th>
              <th>Contact</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {mockTenants.map((t, i) => (
              <tr key={i}>
                <td><input type="checkbox" /></td>
                <td>{t.tenantName || <span style={{ color: '#a0aec0' }}>—</span>}</td>
                <td><span className="badge badge-primary">{t.flat}</span></td>
                <td>{t.intercom}</td>
                <td><span className="badge badge-secondary">{t.status}</span></td>
                <td>{t.contact}</td>
                <td style={{ fontSize: '12px', color: '#4361ee' }}>{t.email || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ padding: '12px', fontSize: '12px', color: '#718096' }}>
          Showing 1 to {mockTenants.length} of {mockTenants.length} entries
        </div>
      </div>
    </div>
  </div>
);

export default Tenants;
